module.exports = __webpack_public_path__ + "img/hyu_gallery10.94be35fe.jpg";